export const QUALIFIES_LIST_REQUEST = 'QUALIFIES_LIST_REQUEST'
export const QUALIFIES_LIST_SUCCESS = 'QUALIFIES_LIST_SUCCESS'
export const QUALIFIES_LIST_FAIL = 'QUALIFIES_LIST_FAIL'